import { useLazyQuery } from '@apollo/client/react';

import { bulkReparseCandidatesCountQuery } from '../../services/BulkReparseService';

export const useBulkReparseCandidatesCount = () => {
  const [searchCandidates, { loading, data, error }] = useLazyQuery(
    bulkReparseCandidatesCountQuery,
    {
      fetchPolicy: 'network-only'
    }
  );

  return {
    search: (filter) => searchCandidates({ variables: { filter } }),
    loading,
    count: data?.count ?? null,
    error: error ? 'No se pudo calcular la cantidad de documentos. Intentá de nuevo.' : null
  };
};
